import { cn } from '@/lib/utils';
import { getStatusChipClasses, getStatusDotClass, type StatusChipVariant } from './status-tokens';

function formatStatusLabel(status: string) {
  return status
    .replaceAll('_', ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function StatusChip({
  className,
  color,
  label,
  status,
  variant = 'badge',
}: {
  className?: string;
  color?: string;
  label?: string;
  status: string;
  variant?: StatusChipVariant;
}) {
  const normalizedStatus = status.toUpperCase();
  const customStyle = color ? { backgroundColor: `${color}20`, color } : undefined;
  const dotStyle = color ? { backgroundColor: color } : undefined;
  const displayLabel = label ?? formatStatusLabel(normalizedStatus);

  if (variant === 'table') {
    return (
      <span
        style={customStyle}
        className={cn(
          'inline-flex min-w-20 shrink-0 items-center justify-center whitespace-nowrap rounded-[3px] px-2 py-1 text-sm font-normal leading-none',
          getStatusChipClasses(normalizedStatus, 'table'),
          className,
        )}
      >
        {displayLabel}
      </span>
    );
  }

  return (
    <span
      style={customStyle}
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2 py-0.5 font-medium leading-none',
        variant === 'dot' ? 'gap-1 text-[10px]' : 'border text-xs',
        getStatusChipClasses(normalizedStatus, 'badge'),
        className,
      )}
    >
      {variant === 'dot' ? (
        <span
          style={dotStyle}
          className={cn(
            'inline-block h-1.5 w-1.5 rounded-full',
            getStatusDotClass(normalizedStatus),
          )}
        />
      ) : null}
      {displayLabel}
    </span>
  );
}
